import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { useHandleMutationCompleted } from '../../components/contributions/hooks/useHandleMutationCompleted';
import { EP_QUESTION_DETAILS_QUERY } from '../question/getQuestionDetails';
const UPDATE_ANSWER_MUTATION = gql `
  mutation EP_UpdateAnswer($questionID: String!, $data: EPAnswerInput!) {
    ep_updateAnswer(questionID: $questionID, data: $data) {
      sentForReview
    }
  }
`;
export function useUpdateAnswerMutation(options) {
    const handleMutationCompleted = useHandleMutationCompleted();
    return useGQLMutation(UPDATE_ANSWER_MUTATION, {
        ...options,
        refetchQueries(result) {
            if (!result.data?.ep_updateAnswer.sentForReview) {
                return [EP_QUESTION_DETAILS_QUERY];
            }
            return [];
        },
        onCompleted(data) {
            handleMutationCompleted(data.ep_updateAnswer);
        },
    });
}
